var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Search",
    transform: "translate(1.000000, 1.000000)",
    fill: "#6C7488",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.26086957,13.0217391 C2.52694441,13.0217391 -0.5,9.99479472 -0.5,6.26086957 C-0.5,2.52694441 2.52694441,-0.5 6.26086957,-0.5 C9.99479472,-0.5 13.0217391,2.52694441 13.0217391,6.26086957 C13.0217391,9.99479472 9.99479472,13.0217391 6.26086957,13.0217391 Z M6.26086957,12.0217391 C9.44250997,12.0217391 12.0217391,9.44250997 12.0217391,6.26086957 C12.0217391,3.07922916 9.44250997,0.5 6.26086957,0.5 C3.07922916,0.5 0.5,3.07922916 0.5,6.26086957 C0.5,9.44250997 3.07922916,12.0217391 6.26086957,12.0217391 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "10.3290553 11.0361621 11.0361621 10.3290553 18.3535534 17.6464466 17.6464466 18.3535534"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearch);
export default __webpack_public_path__ + "static/media/ico-search.5db511cd.svg";
export { ForwardRef as ReactComponent };